import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import useColorWheel from "@/hooks/useColorWheel";
import { onMounted, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
  serial: {
    type: Number || null,
    default: () => null,
  },
  color: {
    type: String || null,
    default: () => "",
  },
},
  setup(__props) {

const props = __props



const pieceRef = ref();
const { createColorPiece } = useColorWheel();

onMounted(() => {
  const serial = props.serial;
  const color = props.color;
  const chart = createColorPiece({
    elmRef: pieceRef.value,
    data: {
      serial,
      color,
      id: `piece-item-${serial}-${color}`,
    },
    createConfig: {},
  });
  chart.render();
  const divRef = pieceRef.value.children[0];
  divRef.style = "width: 80px;";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "piece_body",
    ref_key: "pieceRef",
    ref: pieceRef
  }, null, 512))
}
}

})